<template>
  <aside class="tw-flex tw-flex-col tw-gap-[38px]">
    <div
      v-for="([statusKey, count], index) in Object.entries(statisticsStatuses).filter(
        ([statusKey]) => statusKey !== STATUS_KEYS.UNDEFINED
      )"
      :key="index"
      class="tw-flex tw-flex-col tw-gap-[10px] tw-items-center tw-justify-center tw-w-[182px] tw-h-[182px] tw-rounded-full"
      :style="{ backgroundColor: statuses[statusKey].bgColor, color: statuses[statusKey].color }"
    >
      <p class="tw-mb-0 tw-text-center tw-text-[16px] tw-font-bold">
        {{ $t(statuses[statusKey].nameKey, statuses[statusKey].nameDefault) }}
      </p>
      <p class="tw-mb-0 tw-text-center tw-text-[35px] tw-font-bold">{{ count }}</p>
    </div>
  </aside>
</template>

<script>
import { statuses, STATUS_KEYS } from "@/views/donor-dashboard/my-contacts/constants";
import { mapState } from "vuex";

export default {
  name: "statuses-panel",

  computed: {
    ...mapState({
      statisticsStatuses: (state) => state.donorMyContacts.statisticsStatuses,
    }),
  },

  data() {
    return {
      statuses,
      STATUS_KEYS,
    };
  },
};
</script>
